import { debounceAsync } from '@dsee/util/async.js';
import { boundApiRequest } from '@/restapi/restapi.base.js';


const doRequest = boundApiRequest('/api/logs/');


function _logSearch(params, runtime) {
    doRequest('save/productSearch', {
        ...params,
        runtime,
    }, {
        messages: false,
    });
}

export const logSearch = debounceAsync(_logSearch, 5000);
